export const getInitialState = () => ({
    fetchStatus: "initial",
    extraProducts: {},
    selected: {},
    error: undefined,
    preOptedAncillaries: {},
    pageLoadTime: {}
});
